function formatSize(bytes, decimal){
  var k = 1024
  var decimals = (typeof decimal === 'undefined') ? 2 : decimal
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var i = Math.floor(Math.log(bytes) / Math.log(k))
  if(bytes === 0) return '0 bytes'
  return Math.round(bytes / Math.pow(k, i), decimals) + ' ' + sizes[i]
}

export default formatSize
